import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

const ProtectedRoute = () => {
    const { user } = useSelector((state) => state.auth);
    const location = useLocation();
    const navigate = useNavigate();

    const isAuthenticated = !!user;

    // Watch for user state changes (e.g., logout after deletion)
    useEffect(() => {
        if (!user) {
            // User was logged out (deleted from DB or session expired)
            navigate('/login', { replace: true, state: { from: location } });
        }
    }, [user, navigate, location]);

    return isAuthenticated ? (
        <Outlet />
    ) : (
        <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default ProtectedRoute;